export enum AttentionSpanAndPersistence { 
    HighAttentionQuitePersistent = 1,
    LowAttentionQuitePersistent = 3
    }